<div class="avatar-wrapper" [matMenuTriggerFor]="menu">
  <span class="material-icons avatar-icon" translate="no">person</span>
  <span class="avatar-label">{{ displayUserName }}</span>
</div>

<mat-menu #menu="matMenu">
  <button routerLink="/profile/settings" mat-menu-item>
    <mat-icon>edit</mat-icon>
    <span>{{ 'edit_profile' | translate }}</span>
  </button>
  <button *allowedRole="'admin'" routerLink="/profile/api-settings" mat-menu-item>
    <mat-icon>lock</mat-icon>
    <span>API Access Settings</span>
  </button>
  <button *allowedRole="'admin'" routerLink="/profile/bots-settings" mat-menu-item>
    <mat-icon class="menu-icon" svgIcon="bot-eye-small"></mat-icon>
    <span>Agents Settings</span>
  </button>
  <button *allowedRole="'admin'" routerLink="/app-settings" mat-menu-item>
    <mat-icon>settings</mat-icon>
    <span>General Settings</span>
  </button>
  <button *allowedRole="'admin'" routerLink="/app-users" mat-menu-item>
    <mat-icon>group</mat-icon>
    <span>Users</span>
  </button>
  <button *allowedRole="'admin'" routerLink="/app-queue" mat-menu-item>
    <mat-icon>queue</mat-icon>
    <span>Queue Admin</span>
  </button>
  <button *allowedRole="'admin'" routerLink="/analytics" mat-menu-item>
    <mat-icon>analytics</mat-icon>
    <span>Analytics</span>
  </button>
  <button mat-menu-item (click)="logout()">
    <mat-icon>exit_to_app</mat-icon>
    <span>{{ 'logout' | translate }}</span>
  </button>
</mat-menu>
